import pinia from "@/stores/index.js";
import { defineStore } from "pinia";

const usePageStore = defineStore("page", {
  state: () => {
    return {
      pages: [],
      currentPage: {},
      isDragging: false, //記錄是否處於拖拽狀態
      isCategory: false, //記錄目前拖拽的組件是否是商品分類
      tempPageObj: {}, //拖拽已存在的組件前，記錄尚未拖拽前的頁面
      movingObj: {}, //記錄被拖拽的組件(已存在的)
      isMoved: false, //記錄已存在的組件是否有拖拽成功
      showConfigPanel: false,

      editing: { rowIndex: null, columnIndex: null, obj: {} },
      isLoadingImage: false,
    };
  },
});

export const storePage = usePageStore(pinia);
